import type { IHeroBanner } from '~/components/widget/hero-banner/types'
import type { IWidgetAdsBlock } from '~/components/widget/ads-block'

export const heroBanner: IHeroBanner = {
  heading: 'Кредиты в Бишкеке',
  text: 'На странице представлен список доступных кредитов от банков и микрофинансовых организаций Кыргызстана.',
  image: '/images/photostock/credits.avif',
  image_islamic: '/images/photostock/credits_islamic.png'
}

export const ctaBanner: IWidgetAdsBlock = {
  heading: 'Купите авто в салонах партнеров Бакай Банка',
  text: 'Теперь можно купить новые автомобили Toyota, Lexus, BMW, KIA или Ravon в кредит!',
  subtext: 'Реклама ОАО "БАКАЙ БАНК"',
  image: '/images/banks/bakai-logo.png',
  url: '/bank/bakai/credits/466',
  action: {
    type: 'internal'
  }
}

export default {
  heroBanner,
  ctaBanner
}
